var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"mt-2 mb-0 py-2 rounded-lg",class:_vm.color.text,attrs:{"color":_vm.type == 'failed'
        ? _vm.color.color
        : _vm.status == 'created' || _vm.status == 'pending' || _vm.status == 'payment_pending'|| _vm.status == 'nego_submitted_buyer' || _vm.status == 'nego_processed'
        ? 'orange'
        : _vm.status == 'nego_submitted_seller'
        ? 'orange darken-4'
        : _vm.status == 'paid' ||
          _vm.status == 'pickup' ||
          _vm.status == 'processed' ||
          _vm.status == 'on_delivery' ||
          _vm.status == 'completed'   || _vm.status == 'payment_approved' || _vm.status == 'nego_approved'
        ? 'green'
        : _vm.status == 'payment_rejected' || _vm.status == 'nego_rejected'
        ? 'red' :
        _vm.color.color}},[_c('div',{staticClass:"d-flex"},[_c('v-icon',{attrs:{"color":_vm.type == 'failed' ? 'error' : _vm.type == 'nego' ? 'white' : 'white'}},[_vm._v(_vm._s(_vm._f("toIconTransaction")(_vm.status)))]),_c('div',{staticClass:"my-auto pl-2 font-size-13"},[(_vm.status == 'pickup')?_c('span',[_vm._v("Sedang menunggu Pickup/Drop Off")]):(_vm.status == 'nego')?_c('span',[_vm._v("Sedang ditinjau")]):_c('span',[_vm._v(_vm._s(_vm._f("toStatusTransaction")(_vm.status)))])])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }